import { initContract } from '@ts-rest/core';
import { z } from 'zod';

export const DownloadSchema = z.object({
  fileName: z.string(),
  bucketName: z.string(),
  mimeType: z.string(),
});

export type DownloadCommand = z.infer<typeof DownloadSchema>;

const c = initContract();

export const downloadContract = c.router({
  download: {
    method: 'POST',
    path: '/download',
    body: DownloadSchema,
    responses: {
      200: c.otherResponse({
        contentType: 'application/octet-stream',
        body: z.any(),
      }),
    },
  },
});
